import { useEffect } from 'react';
import { useUserSession } from '@serpro/login-cidadao-volto/hooks/useUserSession';
import cx from 'classnames';
import withLgpdCookie from 'govbr.lgpd.plugin/components/withLgpdCookie';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { fetchUserHistory } from '../../actions/user_history/user_history';

import HistoryList from './components/HistoryList';
import styles from './UserHistory.module.less';

const messages = defineMessages({
  histTile: {
    id: 'Services you accessed',
    defaultMessage: 'Services you accessed',
  },
});

const UserHistory = ({ performanceCookies }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { items, loading, error } = useSelector((state) => state.user_history);
  const { userSession, sessionState } = useUserSession();

  useEffect(() => {
    if (sessionState !== undefined && performanceCookies) {
      dispatch(fetchUserHistory(userSession?.analyticsId));
    }
  }, [dispatch, userSession, sessionState, performanceCookies]);

  const itemsClasses = cx('user-history', styles.items, {
    [styles.loaded]: items.length > 0,
  });

  // if (loading) {
  //   return <div>Loading...</div>;
  // }

  // if (error) {
  //   return <div>Error: {error}</div>;
  // }

  if (loading || error || items?.length === 0 || !performanceCookies) {
    return null;
  }

  return (
    <section className={itemsClasses} aria-labelledby="history-title">
      <div className="ui container">
        <h2 id="history-title" className="text-center pt-4">
          {intl.formatMessage(messages.histTile)}
        </h2>
        <HistoryList items={items} />
      </div>
    </section>
  );
};

export default withLgpdCookie(UserHistory);
